import { useTranslation } from 'next-i18next';
import {
  BuildingsTown,
  CalendarHeart,
  Clock,
  Cutlery,
  MusicNotes,
  PiggyBank,
  RingDiamond,
  UserDouble,
} from '@bridebook/aura/src/icons';

export const icons = [
  <PiggyBank key={0} width={24} height={24} />,
  <CalendarHeart key={1} width={24} height={24} />,
  <Clock key={2} width={16} height={16} />,
  <UserDouble key={3} width={16} height={16} />,
  <BuildingsTown key={4} width={24} height={24} />,
  <RingDiamond key={5} width={24} height={24} />,
  <MusicNotes key={6} width={24} height={24} />,
  <Cutlery key={7} width={24} height={24} />,
];

export const useQuickFactsTitles = () => {
  const { t } = useTranslation('search');

  return {
    weddingBudget: t('quickFacts.weddingBudget'),
    monthGetMarried: t('quickFacts.monthGetMarried'),
    avgLeadTime: t('quickFacts.avgLeadTime'),
    avgGuests: t('quickFacts.avgGuests'),
    popularCity: t('quickFacts.popularCity'),
    hiddenGem: t('quickFacts.hiddenGem'),
    weddingTheme: t('quickFacts.weddingTheme'),
    localTrend: t('quickFacts.localTrend'),
  };
};
